import React from 'react'
import { FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from 'react-router';
import { DataGrid } from "@mui/x-data-grid";
import { Edit } from '@mui/icons-material';
import Paper from "@mui/material/Paper";
import { DownOutlined, PlusOutlined } from '@ant-design/icons';
import test from '../../assets/images/test.png'
import reward from "../../assets/images/Component 6.png";
import product from "../../assets/images/product.png";
import state from "../../assets/images/State Icons 2.png";
import oil from "../../assets/images/oil.png";
import tire from "../../assets/images/tire.png";
import battery from "../../assets/images/batteryy.png";
import care from "../../assets/images/car-care.png";
import { KeyboardArrowDown } from "@mui/icons-material";
import Executed from "../../assets/svg/execued.icon.svg";
import Executing from "../../assets/svg/executing.icon.svg";
import Processing from "../../assets/svg/processing.icon.svg";
import Cancelled from "../../assets/svg/cancelled.icon.svg";
import Conforimed from "../../assets/svg/Confirmed.svg";
import Compeleted from "../../assets/svg/Completed.svg";
import Postpond from "../../assets/svg/postpond.icon.svg";
import Help from "../../assets/svg/HelpIcon.svg";
import { BarChart, PieChart } from "@mui/x-charts";
import { ProgressBar } from "react-bootstrap";
import Oil from "../../assets/svg/Services Icons Oil.svg";
import Maintenance from "../../assets/svg/Services Icons (1).svg";
import Tire from "../../assets/svg/Services Icons (2).svg";
import Carcare from "../../assets/svg/Services Icons.svg";
import Battery from "../../assets/svg/BatteryIcon.svg";
import './Dashboard.css'

export default function Dashboard() {

    const navigate = useNavigate();
  
      const goToOrders = () => {
        navigate("/orders");
      };

      // const columns = [
      //   {
      //     field: "id",
      //     headerName: "Order ID",
      //     width: isSidebarOpen ? 70 : 90,
      //   },
      //   {
      //     field: "Name",
      //     headerName: "Client Name",
      //     width: isSidebarOpen ? 110 : 130,
      //   },
      //   {
      //     field: "Mobile",
      //     headerName: "Mobile N.",
      //     width: isSidebarOpen ? 120 : 135,
      //   },
      //   {
      //     field: "Service",
      //     headerName: "Service",
      //     width: isSidebarOpen ? 105 : 130,
      //     renderCell: () => {
      //       return (
      //         <div>
      //           <img
      //             src={oil}
      //             alt="Confirmed state icon"
      //             className="mx-1"
      //             style={{ width: "20px", height: "20px" }}
      //           />
      //           <img
      //             src={tire}
      //             alt="Confirmed state icon"
      //             className="mx-1"
      //             style={{ width: "20px", height: "20px" }}
      //           />
      //           <img
      //             src={battery}
      //             alt="Confirmed state icon"
      //             className="mx-1"
      //             style={{ width: "20px", height: "20px" }}
      //           />
      //           <img
      //             src={care}
      //             alt="Confirmed state icon"
      //             className="mx-1"
      //             style={{ width: "20px", height: "20px" }}
      //           />
      //         </div>
      //       );
      //     },
      //   },
      //   {
      //     field: "Date",
      //     headerName: "Created Date",
      //     width: isSidebarOpen ? 120 : 140,
      //   },
      //   {
      //     field: "Time",
      //     headerName: "Time",
      //     width: isSidebarOpen ? 140 : 150,
      //   },
      //   {
      //     field: "Location",
      //     headerName: "Location",
      //     width: isSidebarOpen ? 125 : 130,
      //   },
      //   {
      //     field: "State",
      //     headerName: "State",
      //     width: isSidebarOpen ? 110 : 120,
      //     renderCell: () => {
      //       return (
      //         <div style={{ display: "flex", alignItems: "center" }}>
      //           <img
      //             src={state}
      //             alt="Confirmed state icon"
      //             style={{ width: "20px", height: "20px" }}
      //           />
      //           <span className="mx-2">Confirmed</span>
      //         </div>
      //       );
      //     },
      //   },
      //   {
      //     field: "Actions",
      //     headerName: "Actions",
      //     width: isSidebarOpen ? 120 : 135,
      //     renderCell: (params) => {
      //       const handleEdit = (event) => {
      //         event.stopPropagation();
      //         console.log("Edit clicked for ID:", params.row.id);
      //       };
      //       const handleDetails = (event) => {
      //         event.stopPropagation();
      //         console.log("Details clicked for ID:", params.row.id);
      //       };
      //       return (
      //         <div>
      //           <IconButton
      //             onClick={handleEdit}
      //             color="default"
      //             aria-label="edit"
      //             size="small"
      //           >
      //             <PlusOutlined />
      //           </IconButton>
      //           <IconButton
      //             onClick={handleEdit}
      //             color="default"
      //             aria-label="edit"
      //             size="small"
      //           >
      //             <Edit />
      //           </IconButton>
      //           <IconButton
      //             onClick={handleDetails}
      //             color="default"
      //             aria-label="delete"
      //             size="small"
      //           >
      //             <DownOutlined />
      //           </IconButton>
      //         </div>
      //       );
      //     },
      //   },
      // ];
        
      const columns = [
    {
      field: "id",
      headerName: "Order ID",
      flex: 0.5,
      minWidth: 70,
    },
    {
      field: "Name",
      headerName: "Client Name",
      flex: 1,
      minWidth: 110,
    },
    {
      field: "Mobile",
      headerName: "Mobile N.",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "Service",
      headerName: "Service",
      flex: 1,
      minWidth: 105,
      renderCell: () => {
        return (
          <div>
            <img
              src={oil}
              alt="Confirmed state icon"
              className="mx-1"
              style={{ width: "20px", height: "20px" }}
            />
            <img
              src={tire}
              alt="Confirmed state icon"
              className="mx-1"
              style={{ width: "20px", height: "20px" }}
            />
            <img
              src={battery}
              alt="Confirmed state icon"
              className="mx-1"
              style={{ width: "20px", height: "20px" }}
            />
            <img
              src={care}
              alt="Confirmed state icon"
              className="mx-1"
              style={{ width: "20px", height: "20px" }}
            />
          </div>
        );
      },
    },
    {
      field: "Date",
      headerName: "Created Date",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "Time",
      headerName: "Time",
      flex: 1,
      minWidth: 140,
    },
    {
      field: "Location",
      headerName: "Location",
      flex: 1,
      minWidth: 125,
    },
    {
      field: "State",
      headerName: "State",
      flex: 1,
      minWidth: 110,
      renderCell: () => {
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              src={state}
              alt="Confirmed state icon"
              style={{ width: "20px", height: "20px" }}
            />
            <span className="mx-2">Confirmed</span>
          </div>
        );
      },
    },
    {
      field: "Actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        const handleEdit = (event) => {
          event.stopPropagation();
          console.log("Edit clicked for ID:", params.row.id);
        };

        const handleDetails = (event) => {
          event.stopPropagation();
          console.log("Details clicked for ID:", params.row.id);
        };

        return (
          <div>
            <IconButton
              onClick={handleEdit}
              color="default"
              aria-label="edit"
              size="small"
            >
              <PlusOutlined />
            </IconButton>
            <IconButton
              onClick={handleEdit}
              color="default"
              aria-label="edit"
              size="small"
            >
              <Edit />
            </IconButton>
            <IconButton
              onClick={handleDetails}
              color="default"
              aria-label="details"
              size="small"
            >
              <DownOutlined />
            </IconButton>
          </div>
        );
      },
    },
      ];

      const rows = [
        {
          id: 1,
          Name: "Menna Ashraf",
          Mobile: "01003247882",
          Service: "",
          Date: "July 20 . 2024 ",
          Time: "09:00 am 12:00 pm",
          Location: "Masr Elgedida",
          state : "" ,
          Actions: "",
        },
        {
          id: 1,
          Name: "Menna Ashraf",
          Mobile: "01003247882",
          Service: "",
          Date: "July 20 . 2024 ",
          Time: "09:00 am 12:00 pm",
          Location: "Masr Elgedida",
          State: "Confirmed",
          Actions: "",
        },
        {
          id: 1,
          Name: "Menna Ashraf",
          Mobile: "01003247882",
          Service: "",
          Date: "July 20 . 2024 ",
          Time: "09:00 am 12:00 pm",
          Location: "Masr Elgedida",
          State: "Confirmed",
          Actions: "",
        },
        {
          id: 1,
          Name: "Menna Ashraf",
          Mobile: "01003247882",
          Service: "",
          Date: "July 20 . 2024 ",
          Time: "09:00 am 12:00 pm",
          Location: "Masr Elgedida",
          State: "Confirmed",
          Actions: "",
        },
        {
          id: 1,
          Name: "Menna Ashraf",
          Mobile: "01003247882",
          Service: "",
          Date: "July 20 . 2024 ",
          Time: "09:00 am 12:00 pm",
          Location: "Masr Elgedida",
          State: "Confirmed",
          Actions: "",
        },
        {
          id: 1,
          Name: "Menna Ashraf",
          Mobile: "01003247882",
          Service: "",
          Date: "July 20 . 2024 ",
          Time: "09:00 am 12:00 pm",
          Location: "Masr Elgedida",
          State: "Confirmed",
          Actions: "",
        },
        {
          id: 1,
          Name: "Menna Ashraf",
          Mobile: "01003247882",
          Service: "",
          Date: "July 20 . 2024 ",
          Time: "09:00 am 12:00 pm",
          Location: "Masr Elgedida",
          State: "Confirmed",
          Actions: "",
        },
        {
          id: 1,
          Name: "Menna Ashraf",
          Mobile: "01003247882",
          Service: "",
          Date: "July 20 . 2024 ",
          Time: "09:00 am 12:00 pm",
          Location: "Masr Elgedida",
          State: "Confirmed",
          Actions: "",
        },
        {
          id: 1,
          Name: "Menna Ashraf",
          Mobile: "01003247882",
          Service: "",
          Date: "July 20 . 2024 ",
          Time: "09:00 am 12:00 pm",
          Location: "Masr Elgedida",
          State: "Confirmed",
          Actions: "",
        },
      ];
    
  const paginationModel = { page: 0, pageSize: 5 };
  
  const dashboardDetails = [
    {
      name: "Total Orders",
      total: 250,
    },
    {
      name: "Total Products",
      total: 100,
    },
    {
      name: "Total Products",
      total: 500,
    },
    {
      name: "Total Revenue",
      total: "6.800.00 EGP",
    },
  ];
  const orderDetails = [
    {
      Status: "Executed Orders",
      total: 80,
      img: Executed,
    },
    {
      Status: "Executing Orders",
      total: 24,
      img: Executing,
    },
    {
      Status: "Confirmed Orders",
      total: 80,
      img: Conforimed,
    },
    {
      Status: "Completed Orders",
      total: 16,
      img: Compeleted,
    },
    {
      Status: "Postponed Orders",
      total: 10,
      img: Postpond,
    },
    {
      Status: "Help Request Orders",
      total: 10,
      img: Help,
    },
    {
      Status: "Processing Orders",
      total: 20,
      img: Processing,
    },
    {
      Status: "Canceled Orders",
      total: 10,
      img: Cancelled,
    },
  ];
  const dataset = [
    { netProfit: 60, sales: 95, month: "Jan" },
    { netProfit: 62, sales: 42, month: "Feb" },
    { netProfit: 45, sales: 70, month: "Mar" },
    { netProfit: 60, sales: 38, month: "Apr" },
    { netProfit: 57, sales: 69, month: "May" },
    { netProfit: 58, sales: 48, month: "June" },
    { netProfit: 42, sales: 85, month: "July" },
    { netProfit: 20, sales: 49, month: "Aug" },
    { netProfit: 27, sales: 69, month: "Sept" },
    { netProfit: 31, sales: 30, month: "Oct" },
    { netProfit: 39, sales: 29, month: "Nov" },
    { netProfit: 40, sales: 70, month: "Dec" },
  ];
  const chartSetting = {
    yAxis: [
      {
        width: 60,
        tickMinStep: 10,
        min: 0,
        max: 100,
      },
    ],
    height: 500,
  };

  const valueFormatter = (value) => {
    return `${value}mm`;
  };
  const progressData = [
    { label: "Oil & Filter Orders", image: Oil, now: 86, variant: "warning" },
    { label: "Tire Orders", image: Tire, now: 82, variant: "secondary" },
    { label: "Battery Orders", image: Battery, now: 75, variant: "danger" },
    {
      label: "Maintenance Orders",
      image: Maintenance,
      now: 50,
      variant: "success",
    },

    { label: "Car Care Orders", image: Carcare, now: 24, variant: "string" },
  ];

    return (
      <>
        <div className="m-4 min-vh-100">
          <div className="dashboard-header py-3">
            <h5 className="fw-bold">Welcome Back, Ahmed</h5>
            <p className="dashboard-main-color">
              Track, manage, and optimize with ease.
            </p>
          </div>
          <div className=" shadow  rounded rounded-4 bg-white border p-4">
            <div className="d-flex justify-content-between align-items-center ">
              <h6>Business analytics</h6>
              <button className="btn btn-light text-dark">
                Last Week <KeyboardArrowDown />{" "}
              </button>
            </div>
            <div className="row my-2">
              {dashboardDetails.map((objValue) => (
                <div className="col-md-3 col-sm-12  ">
                  <div className=" shadow rounded-3 text-center py-3 my-2 gap-2">
                    {" "}
                    <h6 className="fw-bold">{objValue.name}</h6>
                    <p className="dashboard-main-color">{objValue.total}</p>
                  </div>
                </div>
              ))}

              {orderDetails.map((status) => (
                <div className="col-md-3 col-sm-12  ">
                  <div className="rounded-4 my-3 px-3 py-4 gap-3 dash-order-details">
                    {" "}
                    <div className="d-flex justify-content-between align-items-center">
                      {" "}
                      <div className="d-flex align-items-center gap-2 w-100">
                        {" "}
                        <img
                          style={{ width: "25px" }}
                          src={status.img}
                          alt="ordr-status"
                        />
                        <h6 className="fw-bold p-0 m-0">{status.Status}</h6>
                      </div>
                      <p className="p-0 m-0">{status.total}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className=" shadow  rounded rounded-4 bg-white border p-4 my-3">
            <div className="d-flex justify-content-between align-items-center ">
              <h6 className="fw-bold">Sales Summary</h6>
              <button className="btn btn-light text-dark">
                Today <KeyboardArrowDown />{" "}
              </button>
            </div>
            <div>
              <BarChart
                dataset={dataset}
                xAxis={[{ scaleType: "band", dataKey: "month" }]}
                borderRadius={25}
                series={[
                  {
                    dataKey: "netProfit",
                    label: "Net Profit",
                    valueFormatter,
                    color: "#8979FF",
                  },
                  {
                    dataKey: "sales",
                    label: "Sales",
                    valueFormatter,
                    color: "#FF928A",
                  },
                ]}
                {...chartSetting}
              />
            </div>
          </div>
          <div className="row my-4">
            <div className="col-md-6 col-sm-12">
              <div className="border rounded rounded-4 shadow ">
                <div className="d-flex justify-content-between align-items-center m-3 border-bottom ">
                  {" "}
                  <h6 className="fw-bold">Sales Analytics</h6>
                  <button className="btn dashboard-main-color">View all</button>
                </div>
                {/* <div className="m-3">
                        <label>Oil & Filter orders</label>
                        <ProgressBar   variant="warning" now={86} />
      <ProgressBar variant="secondary" now={82} />
      <ProgressBar variant="danger" now={75} />
      <ProgressBar variant="success" now={50} /></div> */}
                <div className="m-3">
                  {progressData.map((item, index) => (
                    <div>
                      {" "}
                      <div
                        key={index}
                        className="d-flex align-items-center my-2"
                        style={{ gap: "5x" }}
                      >
                        <img
                          src={item.image}
                          alt={item.label}
                          style={{ width: 30, height: 30 }}
                        />
                        <h6 className="dashboard-main-color m-0 p-0">
                          {item.label}
                        </h6>
                      </div>{" "}
                      <div style={{ flexGrow: 1 }}>
                        <ProgressBar
                          now={item.now}
                          variant={item.variant}
                          style={{ height: "10px" }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-md-6 col-sm-12">
              <div className=" dash-pie-chart border rounded rounded-4 shadow ">
                <div className="d-flex justify-content-center align-items-center">
                  {" "}
                  <PieChart
                    series={[
                      {
                        data: [
                          {
                            id: 0,
                            value: 152,
                            label: "Current",
                            color: "#8979FF",
                          },
                          { id: 1, value: 131, label: "New", color: "#FF928A" },
                          {
                            id: 2,
                            value: 97,
                            label: "Target",
                            color: "#3CC3DF",
                          },
                        ],
                      },
                    ]}
                    width={400}
                    height={350}
                    slotProps={{
                      legend: {
                        direction: "column",
                        position: { vertical: "middle", horizontal: "right" },
                        padding: -10,
                        labelStyle: {
                          fontSize: 14,
                          fontWeight: 500,
                        },
                      },
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Recent orders */}
        <div className="recent-orders border border-1 rounded-3 m-4">
          {/* header  */}
          <div className="recent-header p-3">
            <div className="d-flex justify-content-between align-items-center">
              <p className="my-sm-2 fs-5 my-md-0 fw-bold">Recent Orders</p>
              <button
                onClick={goToOrders}
                className=" bg-white border-0 text-muted"
              >
                View All
              </button>
            </div>
            <div className="text-end my-3 me-1">
              <FormControl sx={{ width: "40ch" }} variant="filled">
                <InputLabel htmlFor="outlined-adornment-password">
                  Search by item code, name, category...
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password"
                  type={"text"}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton edge="end">{<SearchIcon />}</IconButton>
                    </InputAdornment>
                  }
                  label="Search by ID, name, category..."
                />
              </FormControl>
            </div>
          </div>
          {/* table  */}
          <div className="recent-table">
            <Paper sx={{ height: 400, width: "100%" }}>
              <DataGrid
                rows={rows}
                columns={columns}
                initialState={{ pagination: { paginationModel } }}
                pageSizeOptions={[5, 10]}
                checkboxSelection
                sx={{ border: 0 }}
              />
            </Paper>
          </div>
        </div>
        {/* top  */}
        <div className="top-clients-products m-4 d-flex justify-content-between align-items-center gap-3">
          <div className="top-clients border border-1 rounded-3 p-3 w-50">
            <div className="top-clients-header d-flex border-bottom border-bottom-1 justify-content-between align-items-center pt-1 pb-3">
              <p className=" fs-5 fw-semibold my-0">Top Clients</p>
              <p className="my-0">View all</p>
            </div>
            <div className="dashboard-client-data d-flex justify-content-between align-items-center my-4">
              <div className=" d-flex justify-content-center align-items-start">
                <div>
                  <img src={test} className="w-75" alt="" />
                </div>
                <div className=" d-flex flex-column align-items-start">
                  <p className=" my-0 fw-semibold">Menna Ashraf</p>
                  <p className=" my-0 small text-muted">15 orders</p>
                </div>
                <div className=" mx-2">
                  <img src={reward} alt="" />
                </div>
              </div>
              <div>
                <p className=" my-0 fw-semibold">40.000 EGP</p>
              </div>
            </div>
            <div className="dashboard-client-data d-flex justify-content-between align-items-center my-4">
              <div className=" d-flex justify-content-center align-items-start">
                <div>
                  <img src={test} className="w-75" alt="" />
                </div>
                <div className=" d-flex flex-column align-items-start">
                  <p className=" my-0 fw-semibold">Menna Ashraf</p>
                  <p className=" my-0 small text-muted">15 orders</p>
                </div>
                <div className=" mx-2">
                  <img src={reward} alt="" />
                </div>
              </div>
              <div>
                <p className=" my-0 fw-semibold">40.000 EGP</p>
              </div>
            </div>
            <div className="dashboard-client-data d-flex justify-content-between align-items-center my-4">
              <div className=" d-flex justify-content-center align-items-start">
                <div>
                  <img src={test} className="w-75" alt="" />
                </div>
                <div className=" d-flex flex-column align-items-start">
                  <p className=" my-0 fw-semibold">Menna Ashraf</p>
                  <p className=" my-0 small text-muted">15 orders</p>
                </div>
                <div className=" mx-2">
                  <img src={reward} alt="" />
                </div>
              </div>
              <div>
                <p className=" my-0 fw-semibold">40.000 EGP</p>
              </div>
            </div>
            <div className="dashboard-client-data d-flex justify-content-between align-items-center mt-4 mb-2">
              <div className=" d-flex justify-content-center align-items-start">
                <div>
                  <img src={test} className="w-75" alt="" />
                </div>
                <div className=" d-flex flex-column align-items-start">
                  <p className=" my-0 fw-semibold">Menna Ashraf</p>
                  <p className=" my-0 small text-muted">15 orders</p>
                </div>
                <div className=" mx-2">
                  <img src={reward} alt="" />
                </div>
              </div>
              <div>
                <p className=" my-0 fw-semibold">40.000 EGP</p>
              </div>
            </div>
          </div>
          <div className="top-products border border-1 rounded-3 p-3  w-50">
            <div className="top-products-header d-flex border-bottom border-bottom-1 justify-content-between align-items-center pt-1 pb-3">
              <p className=" fs-5 fw-semibold my-0">Top Products</p>
              <p className="my-0">View all</p>
            </div>
            <div className="dashboard-products-data d-flex justify-content-between align-items-center my-4">
              <div className=" d-flex justify-content-center align-items-start">
                <div>
                  <img src={product} className="w-75" alt="" />
                </div>
                <div className=" d-flex flex-column align-items-start">
                  <p className=" my-0 fw-semibold">Shell Helix HX6 15W-50</p>
                  <p className=" my-0 small text-muted">200 orders</p>
                </div>
              </div>
              <div>
                <p className=" my-0 fw-semibold">100.000 EGP</p>
              </div>
            </div>
            <div className="dashboard-products-data d-flex justify-content-between align-items-center my-4">
              <div className=" d-flex justify-content-center align-items-start">
                <div>
                  <img src={product} className="w-75" alt="" />
                </div>
                <div className=" d-flex flex-column align-items-start">
                  <p className=" my-0 fw-semibold">Shell Helix HX6 15W-50</p>
                  <p className=" my-0 small text-muted">200 orders</p>
                </div>
              </div>
              <div>
                <p className=" my-0 fw-semibold">100.000 EGP</p>
              </div>
            </div>{" "}
            <div className="dashboard-products-data d-flex justify-content-between align-items-center my-4">
              <div className=" d-flex justify-content-center align-items-start">
                <div>
                  <img src={product} className="w-75" alt="" />
                </div>
                <div className=" d-flex flex-column align-items-start">
                  <p className=" my-0 fw-semibold">Shell Helix HX6 15W-50</p>
                  <p className=" my-0 small text-muted">200 orders</p>
                </div>
              </div>
              <div>
                <p className=" my-0 fw-semibold">100.000 EGP</p>
              </div>
            </div>{" "}
            <div className="dashboard-products-data d-flex justify-content-between align-items-center mt-4 mb-2">
              <div className=" d-flex justify-content-center align-items-start">
                <div>
                  <img src={product} className="w-75" alt="" />
                </div>
                <div className=" d-flex flex-column align-items-start">
                  <p className=" my-0 fw-semibold">Shell Helix HX6 15W-50</p>
                  <p className=" my-0 small text-muted">200 orders</p>
                </div>
              </div>
              <div>
                <p className=" my-0 fw-semibold">100.000 EGP</p>
              </div>
            </div>
          </div>
        </div>
      </>
    );
}
